import { render } from "./AreaComercioSelect.vue?vue&type=template&id=e70c33e4"
import script from "./AreaComercioSelect.vue?vue&type=script&lang=js"
export * from "./AreaComercioSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__